import Nav from "@/components/Header/Nav/Nav.tsx";
import Footer from "@/components/Footer/Footer.tsx";
import GridComponent from "@/components/GridComponent/GridComponent";
import OpenMenuBlock from "@/components/OpenMenuBlock/OpenMenuBlock";
import ServiceBlockBerlinGrid from "@/components/ServiceBlockBerlin/ServiceBlockBerlinGrid";
import type { Service } from "@/components/ServiceBlockBerlin/ServiceBlockBerlin";
import VideoContainer from "@/components/VideoContainer/VideoContainer";
import ImageContainer from "@/components/ImageContainer/ImageContainer";
import DoubleBlock from "@/components/DoubleBlock/DoubleBlock";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

const UberUns = () => {
  const { t } = useTranslation("pages");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Отримуємо послуги з перекладів
  const servicesData = t("uberUns.services", { returnObjects: true }) as Array<{
    title: string;
    description: string;
  }>;

  const services: Service[] = servicesData.map((service, index) => ({
    id: `0${index + 1}`,
    title: service.title,
    description: service.description,
  }));

  // Отримуємо grid items з перекладів
  const gridItems = t("uberUns.grid.items", { returnObjects: true }) as Array<{
    title: string;
    description: string;
  }>;

  const gridData = [
    {
      icon: "/images/Grid/superman-ico.svg",
      title: gridItems[0].title,
      description: gridItems[0].description,
    },
    {
      icon: "/images/Grid/finance-report-ico.svg",
      title: gridItems[1].title,
      description: gridItems[1].description,
    },
    {
      icon: "/images/Grid/protection-ico.svg",
      title: gridItems[2].title,
      description: gridItems[2].description,
    },
    {
      icon: "/images/Grid/garant-ico.svg",
      title: gridItems[3].title,
      description: gridItems[3].description,
    },
    {
      icon: "/images/Grid/graph-ico.svg",
      title: gridItems[4].title,
      description: gridItems[4].description,
    },
    {
      icon: "/images/Grid/cert-ico.svg",
      title: gridItems[5].title,
      description: gridItems[5].description,
    },
    {
      icon: "/images/Grid/target-ico.svg",
      title: gridItems[6].title,
      description: gridItems[6].description,
    },
    {
      icon: "/images/Grid/chckcar-ico.svg",
      title: gridItems[7].title,
      description: gridItems[7].description,
    },
    {
      icon: "/images/Grid/global-care-ico.svg",
      title: gridItems[8].title,
      description: gridItems[8].description,
    },
  ];

  return (
    <div>
      <Helmet>
        <title>{t("uberUns.meta.title")}</title>
        <meta name="description" content={t("uberUns.meta.description")} />
      </Helmet>
      <Nav></Nav>
      <DoubleBlock
        leftTitle={t("uberUns.hero.leftTitle")}
        rightText={t("uberUns.hero.rightText")}
      ></DoubleBlock>
      <ImageContainer src="/images/uber-uns-img.webp" alt="uber-uns" />
      <GridComponent items={gridData}></GridComponent>
      <ServiceBlockBerlinGrid services={services}></ServiceBlockBerlinGrid>
      <OpenMenuBlock></OpenMenuBlock>
      <VideoContainer
        videoSource="https://www.youtube-nocookie.com/embed/5g37qEjyfGY"
        title={t("uberUns.video.title")}
      ></VideoContainer>
      <Footer></Footer>
    </div>
  );
};

export default UberUns;
